import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Breadcrumbs from './../block/Breadcrumbs'
import ProductCard from './../block/ProductCard'
import RecommendedSection from './../block/RecommendedSection'
import PromotionsSection from './../block/PromotionsSection'
import TestimonialsSection from './../block/TestimonialsSection'
import FAQSection from './../block/FAQSection'

export default class Product extends Component {

  render() {

    const { data, ajax_data, changeFavorite, favorite, cart, addTocart, user_profile_type } = this.props

    return (
      <>
        <Breadcrumbs items={ajax_data.breadcrumbs} />
        <ProductCard
          options={data?.page_data || {}}
          ajax_data={ajax_data}
          addTocart={addTocart}
          user_profile_type={user_profile_type}
          changeFavorite={changeFavorite}
          favorite={favorite}
        />
        <RecommendedSection
          page_data={data?.page_data || {}}
          products={ajax_data?.popular || []}
          changeFavorite={changeFavorite}
          favorite={favorite}
          cart={cart}
          addTocart={addTocart}
          user_profile_type={user_profile_type}
        />
        <PromotionsSection
          page_data={data?.page_data || {}}
          products={ajax_data?.favorite || []}
          changeFavorite={changeFavorite}
          favorite={favorite}
          cart={cart}
          addTocart={addTocart}
          user_profile_type={user_profile_type}
        />
        <TestimonialsSection
          page_data={data?.page_data || {}}
          feedback={ajax_data?.feedback_ng || []}
          feedback_legal={ajax_data?.feedback_ng_legal || []}
          user_profile_type={user_profile_type}
        />
        <FAQSection
          qwestions={user_profile_type == `legal` ? ( ajax_data?.qwestions_ng_legal || [] ) : ( ajax_data?.qwestions_ng || [] )}
        />
      </>
    )
  }
}

Product.propTypes = {
  data: PropTypes.object,
  ajax_data: PropTypes.object,
  changeFavorite: PropTypes.func,
  favorite: PropTypes.array,
  cart: PropTypes.array,
  addTocart: PropTypes.func,
  user_profile_type: PropTypes.string
}